import PropTypes from "prop-types";

import { GraduationRateCard as CommonGraduationRateCard } from "../../../../../core/compose/cards";

function GraduationRateCard({
  open,
  chosenSchool,
  externalToggle,
  callbackToggle,
  ethnicityStudent,
}) {
  return (
    <CommonGraduationRateCard
      open={open}
      chosenSchool={chosenSchool}
      externalToggle={externalToggle}
      callbackToggle={callbackToggle}
      ethnicityStudent={ethnicityStudent}
    />
  );
}

GraduationRateCard.propTypes = {
  open: PropTypes.bool,
  externalToggle: PropTypes.bool,
  callbackToggle: PropTypes.func,
  chosenSchool: PropTypes.shape(),
  ethnicityStudent: PropTypes.string,
};

export default GraduationRateCard;
